function getFullName(firstName, middleName, lastName) {
    let fullName = firstName ? firstName + ' ' : '';
    if (middleName) fullName = fullName + middleName + ' ';
    if (lastName) fullName = fullName + lastName;
    return fullName;
}

export { getFullName };
